import styled from 'styled-components';

export const StyledAvatarEmpty = styled.div`
  width: 30px;
  height: 30px;
  object-fit: cover;
  border-radius: 50%;
  background-color: #12DFA9;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;

  &.highlighted { 
    background-color: #1890FF;
  }

  span {
    color: #000;
    font-family: Barlow;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    margin-left: 0 !important;
  }

  @media screen and (max-width: 992px) {
    margin-right: 5px;

    span {
      font-size: 11px;
    }
  }
`;
